import {Component, EventEmitter, forwardRef, inject, Input, OnInit, Output} from '@angular/core';
import {FieldValidationService} from '../../core/field-validation.service';
import {DateToolsService} from '../../core/date-tools.service';
import {AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {FieldParameters} from '../../core/definitions/field-parameters';

@Component({
    selector: 'app-edit-field-date-historic',
    templateUrl: './edit-field-date-historic.component.html',
    styleUrls: ['./edit-field-date-historic.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => EditFieldDateHistoricComponent)
        }
    ],
    standalone: false
})
export class EditFieldDateHistoricComponent implements OnInit, ControlValueAccessor {
  // Injections
  private readonly dateTools: DateToolsService = inject(DateToolsService);
  private readonly fieldValidation: FieldValidationService = inject(FieldValidationService);

  @Input() fieldParameters: FieldParameters;
  @Input() field;
  @Input() formControlName;
  @Input() otherFormControlName;
  @Input() placeholder;
  @Output() valueSet = new EventEmitter<any>();

  inFocus: boolean;
  dateControl: AbstractControl;
  otherDateControl: AbstractControl;

  ngOnInit() {
    this.dateControl = this.fieldParameters.sectionsContainer.formGroup.controls[this.formControlName];
    if (this.otherFormControlName) {
      this.otherDateControl = this.fieldParameters.sectionsContainer.formGroup.controls[this.otherFormControlName];
    }
  }

  isInvalid() {
    return this.fieldValidation.isFieldInvalid(this.fieldParameters.sectionsContainer, this.formControlName);
  }

  onFieldBlur() {
    this.inFocus = false;
  }

  onFieldFocus() {
    if (!this.fieldParameters.sectionsContainer.isDialog) {
      this.inFocus = true;
    }
  }

  onValueChange($event) {
    const value = $event.target.value;
    const validDate = this.dateTools.validateDate(value);
    if (!validDate.dd_error_message) {
      this.fieldParameters.object[this.field.name] = validDate.isoDate;
      this.fieldParameters.object[this.field.name + '_precision'] = validDate.precision;
      // this.dateControl.setValue(value);
      if (validDate && this.otherDateControl) {
        this.otherDateControl.updateValueAndValidity();
      }
    }
    this.valueSet.emit(validDate);
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
  }

}
